import React from 'react';
import { DarkCard } from './RankedCard';
import { fmtMinutes } from './usageApi';

const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const HOURS = Array.from({ length: 24 }, (_, h) => h);
const hourLabel = (h) => (h === 0 ? '12a' : h < 12 ? `${h}a` : h === 12 ? '12p' : `${h - 12}p`);

export const UsageHeatmap = ({ cells }) => {
  const grid = {};
  cells.forEach((c) => { grid[`${c.dow}-${c.hour}`] = c.minutes; });
  const max = Math.max(1, ...cells.map((c) => c.minutes));
  return (
    <DarkCard title="Peak hours" hint="IST · active time" testId="usage-heatmap-card">
      <div className="overflow-x-auto">
        <div className="min-w-[520px] grid gap-[3px]" style={{ gridTemplateColumns: '30px repeat(24, minmax(0, 1fr))' }}>
          <span />
          {HOURS.map((h) => <span key={h} className="text-center text-[9px] text-neutral-500">{h % 3 === 0 ? hourLabel(h) : ''}</span>)}
          {DAYS.map((d, di) => (
            <React.Fragment key={d}>
              <span className="text-[10px] leading-4 text-neutral-500">{d}</span>
              {HOURS.map((h) => {
                const v = grid[`${di}-${h}`] || 0;
                return (
                  <div
                    key={h}
                    title={`${d} ${hourLabel(h)} · ${fmtMinutes(v)}`}
                    data-testid={`usage-heatmap-cell-${di}-${h}`}
                    className="h-4 rounded-[3px] transition-transform duration-150 hover:scale-125"
                    style={{ background: v ? `rgba(126,232,226,${0.15 + 0.85 * (v / max)})` : 'rgba(255,255,255,0.05)' }}
                  />
                );
              })}
            </React.Fragment>
          ))}
        </div>
      </div>
    </DarkCard>
  );
};
